export const PlaceActionTypes = {
  SET_PLACES: 'SET_PLACES',
};
